import type { FilterConfig } from '#types/config/components/filter'

export default {
  height: '5.625rem',
  width: '4.375rem'
} satisfies FilterConfig['option']['tileImage']
